/**
 * Top Deals variant picker.
 *
 * The add-to-cart control is a real /cart/add form (see
 * snippets/top-deals-add-to-cart.liquid); the cart drawer app intercepts its
 * submit, adds the item and opens the drawer. Picking a variant only needs to
 * keep the form's hidden id input in sync -- no cart logic here.
 */
document.addEventListener('change', (event) => {
  const select = event.target.closest('.top-deals__variant-select');
  if (!select) return;

  const purchase = select.closest('.top-deals__purchase');
  const form = purchase && purchase.querySelector('.top-deals__form');
  if (!form) return;

  const idInput = form.querySelector('[name="id"]');
  const button = form.querySelector('[type="submit"]');
  const option = select.options[select.selectedIndex];

  if (idInput) idInput.value = select.value;
  if (button) button.disabled = option.disabled;
});

/**
 * Button feedback: spinner while the app adds the item, then a short
 * "Added to cart" state once the drawer opens.
 *
 * The cart drawer app (AMP Slide Cart) handles the request itself and fires no
 * DOM event when it is done, but it does toggle an "open" class on its root
 * element -- so we watch for that. A timeout clears the spinner if the drawer
 * never opens (request failed, app disabled), so the button can't get stuck.
 */
const ADDED_STATE_MS = 2500;
const LOADING_TIMEOUT_MS = 6000;
let pendingButton = null;
let loadingTimer = null;

function finishAdd(added) {
  const button = pendingButton;
  pendingButton = null;
  clearTimeout(loadingTimer);
  if (!button) return;

  button.classList.remove('loading');
  if (!added || button.classList.contains('is-added')) return;

  const label = button.querySelector('span:not(.loading-overlay)');
  if (!label) return;

  const originalText = label.textContent;
  label.textContent = button.dataset.addedText || 'Added to cart';
  button.classList.add('is-added');

  setTimeout(() => {
    label.textContent = originalText;
    button.classList.remove('is-added');
  }, ADDED_STATE_MS);
}

document.addEventListener('click', (event) => {
  const button = event.target.closest('.top-deals__form [type="submit"]');
  if (!button || button.disabled) return;

  if (pendingButton) pendingButton.classList.remove('loading');
  pendingButton = button;
  button.classList.add('loading');

  clearTimeout(loadingTimer);
  loadingTimer = setTimeout(() => finishAdd(false), LOADING_TIMEOUT_MS);
});

const drawerObserver = new MutationObserver(() => {
  const drawer = document.querySelector('.slidecarthq');
  if (pendingButton && drawer && drawer.classList.contains('open')) {
    finishAdd(true);
  }
});
drawerObserver.observe(document.body, {
  attributes: true,
  attributeFilter: ['class'],
  subtree: true
});
